import styles from './FJWatermarkRemoverRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJResultActionButtons from '../../../../common/combineComponents/FJResultActionButtons/FJResultActionButtons';
import classNames from 'classnames';
import FJUtil from '../../../../util/FJUtil.js';
import FJConstant from '../../../../constants/FJConstant.js';

const FJWatermarkRemoverRight = props => {
    const {
        uploadImg,
        setIsDraggingFile,
        taskStatus,
        headerTabIndex,
        isCanDownload,
        onDownload,
        downloadLoading,
        onRetry,
        imageToVideo,
    } = props;

    const renderDownload = () => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== FJConstant.CREATIONS ||
            !isCanDownload
        ) {
            return <div />;
        }

        if (window.isEditPage) return null; // 使用内部的download组件

        return (
            <FJResultActionButtons
                taskStatus={taskStatus}
                headerTabIndex={headerTabIndex}
                isCanDownload={isCanDownload}
                onDownload={onDownload}
                downloadLoading={downloadLoading}
                isShowImageToVideoButton={true}
                imageToVideo={imageToVideo}
            />
        );
    };

    return (
        <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadImg} className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer hideCancelButton={true} isShowProgress={false} rightChildren={renderDownload()} />

            <FJCreationPanelContainer activeHeaderTabIndex={FJConstant.CREATIONS} onRetry={onRetry} />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};

FJWatermarkRemoverRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    taskStatus: PropTypes.string,
    headerTabIndex: PropTypes.string,
    isCanDownload: PropTypes.bool,
    onDownload: PropTypes.func,
    downloadLoading: PropTypes.bool,
    onRetry: PropTypes.func,
    imageToVideo: PropTypes.func,
};

export default FJWatermarkRemoverRight;
